module.exports = __webpack_public_path__ + "media/images/icons/forms_statistics-f165e0956b03c034200dd309734e4963.svg";